import { Helper } from '../../assets/ts/global';

const helper = new Helper();

export default {
    data() {
        return {
            announcementItems: []
        }
    },
    methods: {
        truncate(value, length) {
            return helper.truncate(value, length);
        },
        persianDigit(value) {
            helper.persianDigit(value);
        }
    },
    updated() {
        this.persianDigit();
    },
    mounted() {
        this.announcementItems = payload.announcementItems
    }
}
